const PROMOS = {
  THIRTY_DAYS_FREE: {
    CODE: "thirty-days-free",
    DAYS_FREE: 30,
    CHARGE_NAME: "Ultimate Special Offers - first thirty days free"
  }
};

module.exports = PROMOS;
